import { moveToFulfilled, moveToRejected, objectWithKeys } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { PrivateGroupMembershipAction } from '../../domains/privateGroupMemberships/actions.types';

import { PrivateGroupMemberships } from './types';

export type { PrivateGroupMembershipAction };

const initialState = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<PrivateGroupMemberships, PrivateGroupMembershipAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'PRIVATE_GROUP.USER_MEMBERSHIPS_PENDING': {
      const newPending = objectWithKeys<boolean>(state.pending.byId, action.payload.ids, true);

      return {
        ...state,
        pending: {
          ...state.pending,
          byId: newPending,
        },
      };
    }
    case 'PRIVATE_GROUP.USER_MEMBERSHIPS_FULFILLED':
      return moveToFulfilled(state, action.payload.memberships);
    case 'PRIVATE_GROUP.USER_MEMBERSHIPS_REJECTED':
      return moveToRejected(state, action.payload.ids, action.payload.error);
    default:
      return state;
  }
};

export default reducer;
